const companiesEnums = {
  CVC: 'cvc',
  ARQUITECSOFT: 'arquitecsoft',
  ACUAGYR: 'acuagyr',
  ACUAVALLE: 'acuavalle',
  OZONO: 'ozono',
  EPM: 'epm',
  COMITECQ: 'comitecq',
  AGUASDEBUGA: 'aguasdebuga',
  ENERGUATE: 'energuate',
  BRILLA: 'brilla',
  EPA: 'epa',
  IMEDICAL: 'imedical',
  MESOFOODS:'mesofoods',
  CASTELL: 'castell',
  SYSCASOFT: 'syscasoft',
  DESTINONATURA: 'destinonatura',
  ENLACE: 'enlace',
  FRC: 'frc',
  PROMOAMBIENTAL: 'promoambiental',
  SETTI: 'setti',
  MACROSERVICIOS: 'macroservicios',
  ADMINISTRACIONBIENESCALI: 'administracionbienescali',
  AQUASERVICIOS: 'aquaservicios',
  AQUALIA: 'aqualia',
  PRESTO_MESOFOODS: 'presto-mesofoods',
  OMA_MESOFOODS: 'oma-mesofoods'
}

const companies = [
  {
    nameCompany: companiesEnums.CVC,
    name: 'CVC',
    idCompany: 105,
    idProject: 390,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.ARQUITECSOFT,
    name: 'Arquitecsoft',
    idCompany: 1,
    idProject: 0, // Se selecciona desde la vista. //TODO verificar idProject de Arquitecsoft
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.ACUAGYR,
    name: 'Acuagyr',
    idCompany: 155,
    idProject: 410,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.ACUAVALLE,
    name: 'Acuavalle',
    idCompany: 140,
    idProject: 421,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.OZONO,
    name: 'Ozono',
    idCompany: 163,
    idProject: 432,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.EPM,
    name: 'EPM',
    idCompany: 143,
    idProject: 429,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.COMITECQ,
    name: 'Comité de Cafeteros Quindío',
    idCompany: 147,
    idProject: 438,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.AGUASDEBUGA,
    name: 'Aguas de Buga',
    idCompany: 172,
    idProject: 440,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.ENERGUATE,
    name: 'Energuate',
    idCompany: 178,
    idProject: 456,
    idRequestTypeService: 49
  },
  {
    nameCompany: companiesEnums.BRILLA,
    name: 'Brilla',
    idCompany: 179,
    idProject: 462,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.EPA,
    name: 'EPA',
    idCompany: 112,
    idProject: 506,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.IMEDICAL,
    name: 'iMedical',
    idCompany: 187,
    idProject: 509,
    idRequestTypeService: 52
  },
  {
    nameCompany: companiesEnums.MESOFOODS,
    name: 'Mesofoods',
    idCompany: 190,
    idProject: 512,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.CASTELL,
    name: 'Castell',
    idCompany: 148,
    idProject: 342,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.SYSCASOFT,
    name: 'Syscasoft',
    idCompany: 192,
    idProject: 515,
    idRequestTypeService: -1
  },
  {
    nameCompany: companiesEnums.DESTINONATURA,
    name: 'Destino Natura',
    idCompany: 153,
    idProject: -1,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.ENLACE,
    name: 'Enlace S.A.S.',
    idCompany: 131,
    idProject: -1,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.FRC,
    name: 'FRC SAS',
    idCompany: 152,
    idProject: -1,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.PROMOAMBIENTAL,
    name: 'PromoAmbiental',
    idCompany: 139,
    idProject: -1,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.SETTI,
    name: 'Setti',
    idCompany: 154,
    idProject: -1,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.MACROSERVICIOS,
    name: 'Macroservicios',
    idCompany: 195,
    idProject: 528,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.ADMINISTRACIONBIENESCALI,
    name: 'Administración de Bienes de Cali',
    idCompany: 194,
    idProject: 527,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.AQUASERVICIOS,
    name: 'AquaServicios',
    idCompany: 196,
    idProject: 529,
    idRequestTypeService: 112
  },
  {
    nameCompany: companiesEnums.AQUALIA,
    name: 'Aqualia',
    idCompany: 185,
    idProject: 505,
    idRequestTypeService: 112
  },
  {
    nameCompany: companiesEnums.PRESTO_MESOFOODS,
    name: 'Presto Mesofoods',
    idCompany: 191,
    idProject: 530,
    idRequestTypeService: 48
  },
  {
    nameCompany: companiesEnums.OMA_MESOFOODS,
    name: 'OMA Mesofoods',
    idCompany: 197,
    idProject: 531,
    idRequestTypeService: 48
  },
]

const searchCompany = (nameCompany) => {
  const companyFound = companies.find(company => {
    // TODO, mejorar validación
    if (nameCompany) {
      return nameCompany.toString().toLowerCase() === company.nameCompany
    } else {
      return ''
    }
  })

  return companyFound
}

const searchCompanyById = (idCompany) => {
  const companyFound = companies.find(company => {
    // TODO, mejorar validación
    return idCompany === company.idCompany
  })

  return companyFound
}

export { searchCompany, companiesEnums, searchCompanyById, companies }
